export const BUILD_VERSION = '330d7d23700bf0bdfccd26cd118bddf24d14d3fd';
